import { styled } from 'styled-components';
import { Button, useThemeColor, mq } from '@wistia/vhs';
import type { JSX } from 'react';

const TabsContainer = styled.div<{ $isRightOfPlayer: boolean }>`
  display: flex;
  grid-area: Tabs;
  width: ${({ $isRightOfPlayer }) => ($isRightOfPlayer ? '100%' : '20%')};

  ${mq.smAndDown} {
    width: 100%;
  }
`;

const StyledButton = styled(Button)<{ $isActiveTab: boolean; $isRightOfPlayer: boolean }>`
  color: ${({ theme, $isActiveTab }) =>
    $isActiveTab ? theme.color.brandBlue500 : theme.color.grey900};
  width: ${({ $isRightOfPlayer }) => ($isRightOfPlayer ? '50%' : '')};

  ${mq.smAndDown} {
    width: 50%;
  }
`;

export const ButtonTabs = ({
  tabNames,
  activeTab,
  onTabSelected,
  isRightOfPlayer,
}: {
  tabNames: string[];
  activeTab: string;
  onTabSelected: (tab: string) => void;
  isRightOfPlayer: boolean;
}): JSX.Element => {
  const brandBlue100 = useThemeColor('brandBlue100');

  return (
    <TabsContainer $isRightOfPlayer={isRightOfPlayer}>
      {tabNames.map((tab) => {
        const isActive = tab === activeTab;
        return (
          <StyledButton
            $isActiveTab={isActive}
            $isRightOfPlayer={isRightOfPlayer}
            key={tab}
            colorOverride={isActive ? brandBlue100 : 'transparent'}
            label={tab}
            onClick={() => {
              onTabSelected(tab);
            }}
          />
        );
      })}
    </TabsContainer>
  );
};
